<template>
  <VDatePickerHeader
    data-qa="date-range-slider"
    :value="formattedStartDate"
    @toggle="isMenuOpen = !isMenuOpen"
    @input="handleHeaderInput"
    prev-icon="chevron_left"
    next-icon="chevron_right"
  >
    <v-menu
      :close-on-click="true"
      v-model="isMenuOpen"
      :close-on-content-click="false"
      content-class="date-picker-menu-content"
      :offset-y="true"
    >
      <template v-slot:activator="{ on, attrs }">
        <DateRangeText
          v-on="on"
          v-bind="attrs"
          :startDate="startDate"
          :endDate="endDate"
          :duration="duration"
        />
      </template>
      <VcDateInput
        :firstDayOfWeek="firstDayOfWeek"
        width="292px"
        :range="!duration"
        v-model="formattedDatePickerValue"
      >
      </VcDateInput>
    </v-menu>

  </VDatePickerHeader>
</template>

<script>
  import moment from "moment";
  import {DateRangeText, DatePicker, } from "@/modules/common/components"
  import VcDateInput from "@/modules/common/components/VcDateInput/VcDateInput.vue"
  export default {
    components: {
      DateRangeText,
      DatePicker,
      VcDateInput,
    },
    model: {
      prop: 'startDate',
      event: 'input',
    },
    props: {
      startDate: {
        type: [Date, String],
        required: true,
      },
      endDate: {
        type: [Date, String],
        default: '',
      },
      duration: {
        type: Number,
        default: 0,
      },
      firstDayOfWeek: {
        type: Number,
        default: 0,
      },
    },
    watch: {
      startDate: {
        handler(newVal, oldVal) {
          if (!newVal || !oldVal) {
            return
          }
          if (newVal < oldVal) {
            this.moveForwardCount--
          } else if (newVal > oldVal){
            this.moveForwardCount++
          }
        },
      },
    },
    data() {
      return {
        moveForwardCount: 0,
        isMenuOpen: false,
      }
    },
    methods: {
      handleHeaderInput(val) {
        const didMoveForward = new Date(val) > this.formattedStartDateDateObj
        this.moveForwardCount += didMoveForward ? 1 : -1
        let durationToMove
        if (this.duration) {
          durationToMove = this.duration + 1
          durationToMove = didMoveForward ? durationToMove : -durationToMove
        } else {
          durationToMove = Math.round(( +new Date(this.endDate) - new Date(this.startDate) ) / 86400000)
          if(!didMoveForward) {
            durationToMove = durationToMove * (-1)
          }
          this.$emit('update:startDate', moment(this.startDate).add('days', durationToMove).toDate())
          this.$emit('update:endDate', moment(this.endDate).add('days', durationToMove).toDate())
        }
        const toEmit = moment(this.startDate).add('days', durationToMove).toDate()
        this.$emit('input', toEmit)
      },
    },
    computed: {
      parsedStartDate() {
        return new Date(this.startDate)
      },
      formattedStartDate() {
        const startDateMomentObj = moment(this.startDate)
        startDateMomentObj.add(this.moveForwardCount, 'months') //we're tricking vue to think we're moving months because when we do, it creates a nice animation
        return startDateMomentObj.format('YYYY-MM')
      },
      formattedDatePickerValue: {
        get() {
          const startDateMomentObj = moment(this.startDate)
          const startDateText = startDateMomentObj.format('YYYY-MM-DD')
          const endDateText = this.momentEndDateObj.format('YYYY-MM-DD')
          return [startDateText, endDateText]
        },
        set(val, oldVal) {
          if(!this.duration) {

            const [earlyDate, lateDate] = val
            this.$emit('update:startDate', earlyDate)
            this.$emit('update:endDate', lateDate)
            this.isMenuOpen = false
            return
          }
          const toEmit = new Date(val[0])
          const didMoveForward = toEmit > new Date(this.startDate)
          this.moveForwardCount += didMoveForward ? 1 : -1
          this.isMenuOpen = false
          this.$emit('input', toEmit)
        }

      },
      formattedStartDateDateObj() {
        return new Date(this.formattedStartDate)
      },
      momentEndDateObj() {
        return this.duration ? moment(this.startDate).add(this.duration, 'days') : moment(this.endDate)
      }
    }
  }
</script>

<style lang="scss" scoped>
.v-date-picker-header {
  width: 100%;
  padding: 0;
  ::v-deep {
    > button.v-btn.v-btn--icon {
      color: #999999;
    }
  }
}
.v-picker--date {
  ::v-deep {
    .v-date-picker-header > button.v-btn.v-btn--icon {
      color: #999999;
    }
  }
}
</style>
